import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@root/shared/service/translate.service';

interface Group {
  id: number;
  name: string;
  // staffs: Staff[];
}
interface Staff {
  label: string;
  value: number;
  groups: number[];
}

export const CLEANER_ASSIGN_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CleanerAssignPickerComponent),
  multi: true,
};

@Component({
  selector: 'host-cleaner-assign-picker',
  templateUrl: 'cleaner-assign-picker.component.html',
  styleUrls: ['./cleaner-assign-picker.component.scss'],
  providers: [CLEANER_ASSIGN_PICKER_VALUE_ACCESSOR],
})
export class CleanerAssignPickerComponent implements OnInit, ControlValueAccessor {
  private readonly StaffListApi = '/api/schedule/staff/list';
  private readonly GroupListApi = '/api/schedule/staff_group/all';

  @Input() multiple = true;
  @Input() placeholder;
  @Input() size: 'default' | 'large' = 'default';

  visible = false;

  staffList: Staff[] = [];
  groupList: Group[] = [];

  selectedGroup = -1;
  selectedStaff: Set<number> = new Set();

  textView;

  _registerOnChange: (value: any) => void = (_: any) => {};

  get staffListOfGroup() {
    if (this.selectedGroup === -1) {
      return this.staffList;
    } else {
      return this.staffList.filter((staff) => staff.groups.indexOf(this.selectedGroup) !== -1);
    }
  }

  constructor(private http: HttpClient, private t: TranslateService) {}

  ngOnInit() {
    this.fetchStaffList();
    this.fetchGroupList();
  }

  private fetchStaffList() {
    const params = { page: '1', page_size: '1000' };
    this.http.get(this.StaffListApi, { params }).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.staffList = (rst.data.list || []).map((staff) => ({
          label: staff.name,
          value: staff.id,
          groups: staff.groups.map((g) => g.id),
        }));
        // 防止writeValue的触发早于该接口，导致查找不到对应的被选中条目
        if (this.selectedStaff.size && !this.textView) {
          this.updateTextView();
        }
      }
    });
  }

  private fetchGroupList() {
    this.http.get(this.GroupListApi).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        const list = rst.data.list || [];
        this.groupList = list.map((group) => ({
          ...group,
          // staffs: group.staffs.map(s => ({
          //   label: s.name,
          //   value: s.id,
          // }))
        }));
        this.groupList.unshift({
          name: this.t.syncGet('task.word.opt.all_staff'),
          id: -1,
        });
      }
    });
  }

  onSelectGroup(group: Group) {
    if (this.selectedGroup !== group.id) {
      this.selectedGroup = group.id;
      // 多选要默认选中改组下所以的成员
      this.selectedStaff = this.multiple ? new Set(this.staffListOfGroup.map((s) => s.value)) : new Set([]);
    }

    // if (this.selectedGroup !== group.id) {
    //   this.selectedGroup = group.id;
    //   // this.selectedStaff = group.id === -1 ? new Set(this.staffList.map(s => s.value)) : new Set(group.staff_ids);
    // } else {
    //   this.selectedGroup = null;
    //   this.selectedStaff.clear();
    // }
  }

  onSelectStaff(staff: Staff) {
    if (this.selectedStaff.has(staff.value)) {
      this.selectedStaff.delete(staff.value);
    } else {
      if (this.multiple) {
        this.selectedStaff.add(staff.value);
      } else {
        this.selectedStaff = new Set([staff.value]);
        this.onConfirm();
      }
    }
  }

  onCancel() {
    this.closePanel();
  }

  onConfirm() {
    this.updateTextView();
    this.closePanel();
    this._registerOnChange(Array.from(this.selectedStaff));
  }

  onReset() {
    this.selectedGroup = -1;
    this.selectedStaff = new Set([]);

    this.onConfirm();
  }

  private updateTextView() {
    const size = this.selectedStaff.size;

    if (size === 0) {
      this.textView = null;
    }
    if (size === 1) {
      const staff = this.staffListOfGroup.find((s) => s.value === Array.from(this.selectedStaff)[0]);
      this.textView = staff?.label;
    }
    if (size > 1) {
      this.textView = this.t.syncGet('component.cleaner_assign_picker.textview', { number: size });
    }
  }

  private closePanel() {
    this.visible = false;
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(ids: number[]): void {
    if (ids && !Array.isArray(ids)) {
      ids = [ids];
    }
    this.selectedStaff = new Set(ids || []);
    if (this.staffList.length) {
      this.updateTextView();
    }
  }
}
